import React from 'react';

const SocialProof = () => {
    return (
        <div className="bg-white dark:bg-gray-900">
            <div className="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-16 lg:px-6">
                <dl className="grid max-w-screen-md gap-8 mx-auto text-gray-900 sm:grid-cols-3 dark:text-white">
                    <div className="flex flex-col items-center justify-center">
                        <dt className="mb-2 text-3xl md:text-4xl font-extrabold text-[#1D3351] dark:text-white">1M+</dt>
                        <dd className="font-light text-[#1D3351] dark:text-gray-400">Happy Customers</dd>
                    </div>
                    <div className="flex flex-col items-center justify-center">
                        <dt className="mb-2 text-3xl md:text-4xl font-extrabold text-[#1D3351] dark:text-white">500K+</dt>
                        <dd className="font-light text-[#1D3351] dark:text-gray-400">Products Sold</dd>
                    </div>
                    <div className="flex flex-col items-center justify-center">
                        <dt className="mb-2 text-3xl md:text-4xl font-extrabold text-[#1D3351] dark:text-white">200+</dt>
                        <dd className="font-light text-[#1D3351] dark:text-gray-400">Top Brands</dd>
                    </div>
                </dl>
            </div>
        </div>
    );
}

export default SocialProof;
